import React, { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { notificationsService } from '../services/notificationsService';
import { authService } from '../services/AuthServices';

const Header = () => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.filter(n => !n.isRead).length;
  const [details, setDetails] = useState({});
  const userId = localStorage.getItem('id');


  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    Navigate('/admin/signin');
  };

  useEffect(() => {
    fetchAdminDetails();
    fetchNotifications();
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

    const fetchNotifications = async () => {
        try {
            const response = await notificationsService.getNotifications();
            const data = response.data?.data || [];
            setNotifications(data);
        } catch (error) {
            console.error(error.response?.data?.message || "Failed to fetch transactions");
        }
    };

    const fetchAdminDetails = async () => {
      try {
        const response = await authService.adminDetails(userId);
        const data = response.data?.data || [];
        setDetails(data);
      } catch (error) {
        console.error(error.response?.data?.message || "Failed to fetch details");
      }
    };

    console.log(details)
  return (
    <div className="bg-white shadow-sm border-bottom">
      <style jsx>{`
        :root {
          --primary-color: #6366f1;
          --primary-hover: #5855eb;
          --text-primary: #1f2937;
          --text-secondary: #6b7280;
          --border-color: #e5e7eb;
          --bg-hover: #f9fafb;
        }

        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .nav-link {
          position: relative;
          display: flex;
          align-items: center;
          padding: 0.5rem;
          border-radius: 0.5rem;
          transition: all 0.2s ease;
          text-decoration: none;
          color: var(--text-primary);
        }

        .nav-link:hover {
          background-color: var(--bg-hover);
          color: var(--primary-color);
          text-decoration: none;
        }

        .notification-btn {
          position: relative;
          background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));
          border: none;
          border-radius: 50%;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
          cursor: pointer;
        }

        .notification-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
        }

        .notification-icon {
          width: 20px;
          height: 20px;
          color: white;
        }

        .pulse-indicator {
          position: absolute;
          top: -2px;
          right: -2px;
          width: 12px;
          height: 12px;
          background: #ef4444;
          border: 2px solid white;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
          100% { transform: scale(1); opacity: 1; }
        }

        .dropdown-menu {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          background: white;
          border-radius: 12px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid var(--border-color);
          min-width: 320px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px);
          transition: all 0.3s ease;
        }

        .dropdown-menu.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .dropdown-header {
          padding: 1rem 1.5rem;
          border-bottom: 1px solid var(--border-color);
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-radius: 12px 12px 0 0;
        }

        .notification-item {
          padding: 0.75rem 1.5rem;
          border-bottom: 1px solid #f3f4f6;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .notification-item:hover {
          background-color: var(--bg-hover);
        }

        .notification-item:last-child {
          border-bottom: none;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.875rem;
          background: linear-gradient(135deg, var(--primary-color), var(--primary-hover));
          color: white;
          flex-shrink: 0;
        }

        .profile-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: linear-gradient(135deg, #10b981, #059669);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .profile-avatar:hover {
          border-color: var(--primary-color);
          transform: scale(1.05);
        }

        .badge {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
          border-radius: 0.375rem;
          font-weight: 500;
        }

        .bg-success { background-color: #10b981; color: white; }
        .bg-info { background-color: #06b6d4; color: white; }
        .bg-warning { background-color: #f59e0b; color: white; }
        .bg-primary { background-color: var(--primary-color); color: white; }

        .notification-badge {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
          border-radius: 1rem;
          min-width: 20px;
          text-align: center;
        }

        .menu-toggle {
          display: none;
          background: none;
          border: none;
          font-size: 1.25rem;
          color: var(--text-primary);
          padding: 0.5rem;
          border-radius: 0.375rem;
          transition: all 0.2s ease;
        }

        .menu-toggle:hover {
          background-color: var(--bg-hover);
          color: var(--primary-color);
        }

        @media (max-width: 768px) {
          .menu-toggle {
            display: block;
          }
          .dropdown-menu {
            min-width: 280px;
            right: -10px;
          }
        }

        .profile-info {
          padding: 1rem 1.5rem;
          border-bottom: 1px solid var(--border-color);
        }

        .profile-menu-item {
          padding: 0.75rem 1.5rem;
          display: flex;
          align-items: center;
          transition: all 0.2s ease;
          text-decoration: none;
          color: var(--text-primary);
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          cursor: pointer;
        }

        .profile-menu-item:hover {
          background-color: var(--bg-hover);
          color: var(--primary-color);
          text-decoration: none;
        }

        .profile-menu-item svg {
          margin-right: 0.75rem;
          width: 18px;
          height: 18px;
          fill: currentColor;
        }

        .view-all-link {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          color: var(--primary-color);
          text-align: center;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.2s ease;
          border-radius: 0 0 12px 12px;
          display: block;
        }

        .view-all-link:hover {
          background: linear-gradient(135deg, #e2e8f0, #cbd5e1);
          color: var(--primary-hover);
          text-decoration: none;
        }

        .d-flex { display: flex; }
        .align-items-center { align-items: center; }
        .justify-content-between { justify-content: space-between; }
        .flex-grow-1 { flex-grow: 1; }
        .gap-3 { gap: 0.75rem; }
        .position-relative { position: relative; }
        .mb-0 { margin-bottom: 0; }
        .fw-bold { font-weight: bold; }
        .fw-semibold { font-weight: 600; }
        .text-primary { color: var(--primary-color); }
        .text-muted { color: var(--text-secondary); }
        .me-3 { margin-right: 0.75rem; }
        .me-4 { margin-right: 1rem; }
        .ms-2 { margin-left: 0.5rem; }
        .mb-1 { margin-bottom: 0.25rem; }
        .overflow-auto { overflow: auto; }
        .text-truncate { 
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .min-width-0 { min-width: 0; }
        .small { font-size: 0.875rem; }
        .py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
        .bg-white { background-color: white; }
        .shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); }
        .border-bottom { border-bottom: 1px solid var(--border-color); }

        /* Search bar styling */
        .search-container {
          position: relative;
          max-width: 400px;
          margin-left: 2rem;
        }

        .search-input {
          width: 100%;
          padding: 0.5rem 1rem 0.5rem 2.5rem;
          border: 1px solid var(--border-color);
          border-radius: 0.5rem;
          background-color: #f9fafb;
          transition: all 0.2s ease;
          font-size: 0.875rem;
        }

        .search-input:focus {
          outline: none;
          border-color: var(--primary-color);
          background-color: white;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .search-icon {
          position: absolute;
          left: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          color: var(--text-secondary);
        }

        .unread-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #ef4444;
          color: white;
          font-size: 0.65rem;
          font-weight: bold;
          padding: 2px 6px;
          border-radius: 999px;
          line-height: 1;
          box-shadow: 0 0 0 2px white;
        }

        .dropdown-scroll-container {
          max-height: 400px;
          overflow-y: auto;
          padding-right: 4px;
        }

        /* optional: thinner scrollbar for better UX */
        .dropdown-scroll-container::-webkit-scrollbar {
          width: 6px;
        }
        .dropdown-scroll-container::-webkit-scrollbar-thumb {
          background-color: #d1d5db;
          border-radius: 6px;
        }


      `}</style>

      <nav className="py-3">
        <div className="header-container">
          <div className="d-flex align-items-center justify-content-between">
            {/* Left side - Logo and Search */}
            <div className="d-flex align-items-center flex-grow-1">
              {/* <div className="d-flex align-items-center">
                <h4 className="mb-0 fw-bold text-warning me-4">Dashboard</h4>
              </div> */}
            </div>

            {/* Right side - Notifications and Profile */}
            <div className="d-flex align-items-center gap-3">
              {/* Notifications Dropdown */}
              <div className="position-relative" ref={notificationRef}>
                <button
                  className="notification-btn"
                  onClick={() => setNotificationsOpen(!notificationsOpen)}
                >
                  <svg className="notification-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                  </svg>
                  {unreadCount > 0 && (
                    <span className="unread-badge">
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}

                </button>

                <div className={`dropdown-menu ${notificationsOpen ? 'show' : ''}`}>
                  <div className="dropdown-header">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-semibold">Notifications</h6>
                      <span className="notification-badge">6</span>
                    </div>
                  </div>
                  
                  <div className="dropdown-scroll-container">
                    {notifications.map((notification) => (
                      <div key={notification._id} className="notification-item">
                        <div className="d-flex align-items-start">
                          <div className="avatar me-3">
                            {notification.title?.charAt(0) || 'N'}
                          </div>
                          <div className="flex-grow-1 min-width-0">
                            <div className="d-flex justify-content-between align-items-start mb-1">
                              <p className="mb-0 fw-semibold text-truncate">
                                {notification.title}
                              </p>
                              <small className="text-muted ms-2">
                                {new Date(notification.createdAt).toLocaleString()}
                              </small>
                            </div>
                            <p className="mb-0 text-muted small">{notification.message}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>

              {/* Profile Dropdown */}
              <div className="position-relative" ref={profileRef}>
                <div
                  className="profile-avatar"
                  onClick={() => setProfileOpen(!profileOpen)}
                >
                  SA
                </div>

                <div className={`dropdown-menu ${profileOpen ? 'show' : ''}`}>
                  <div className="profile-info">
                    <div className="d-flex align-items-center">
                      <div className="avatar me-3">{details?.fullName?.split(' ').map(n => n[0]).join('').toUpperCase()}</div>
                      <div>
                        <p className="mb-0 fw-semibold">{details?.fullName}</p>
                        <small className="text-muted">{details?.email}</small>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <button onClick={handleLogout} className="profile-menu-item">
                      <svg viewBox="0 0 24 24">
                        <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                      </svg>
                      Sign Out
                    </button>
                  </div>
                </div>
              </div>

              {/* Mobile Menu Toggle */}
              <button className="menu-toggle">
                <i className="fa fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;